<div>
  <div class="grid-x">
    <div class="cell small-12">
      Chief's Order Category:
    </div>
    <div class="cell small-12">
      @if (categoryFetched) {
        <select [(ngModel)]="this.sideEffect.configuration.chiefsOrderCategory">
          @for (value of chiefsOrderCategoriesDomain.values; track value) {
            <option [value]="value.Code">{{value.Definition}}</option>
          }
        </select>
      }
    </div>
    @if (!categoryFetched) {
      <div class="cell small-12 bold">
        Loading Report Categories...
      </div>
    }
    <div class="cell small-12">
      Communication Template To Use:
    </div>
    <div class="cell small-12">
      @if (reportsFetched) {
        <select [(ngModel)]="this.selectedReportTemplateId" (ngModelChange)="changeReportTemplate($event)">
          @for (reportTemplate of categorizedTemplates(); track reportTemplate) {
            <option [value]="reportTemplate.id">{{reportTemplate.name}}</option>
          }
        </select>
      }
      @if (!reportsFetched) {
        <div class="cell small-12 bold">
          Loading reports...
        </div>
      }
      @if (this.sideEffect.configuration.reportTemplate.id == '') {
        <span class="red">A template needs to be selected.</span>
      }
    </div>
    <div class="cell small-12">
      Transition to execute when the Chief's Order is issued:
    </div>
    <div class="cell small-12">
      <select [(ngModel)]="this.selectedTransitionKey" (ngModelChange)="changeTransition($event)">
        @for (transition of availableTransitions; track transition) {
          <option [value]="transition.key">{{transition.name}}</option>
        }
      </select>
      @if (this.sideEffect.configuration.transition.key == '') {
        <span class="red">A transition needs to be selected.</span>
      }
    </div>
    @if (selectedTransitionToExecuteOnIssuance && selectedTransitionToExecuteOnIssuance.key !== '-1' && selectedTransitionToExecuteOnIssuance.sideEffects && selectedTransitionToExecuteOnIssuance.sideEffects.length > 0) {
      <div>
        {{selectedTransitionToExecuteOnIssuance.name}} executes the following side effects:
        @for (sideEffect of selectedTransitionToExecuteOnIssuance.sideEffects; track sideEffect) {
          <div class="cell small-12">
            {{sideEffect.label}}
          </div>
        }
      </div>
    }
    @if (selectedTransitionToExecuteOnIssuance && selectedTransitionToExecuteOnIssuance.key !== '-1' &&  (!selectedTransitionToExecuteOnIssuance.sideEffects || selectedTransitionToExecuteOnIssuance.sideEffects.length === 0)) {
      <div>
        {{selectedTransitionToExecuteOnIssuance.name}} executes no side effects.
      </div>
    }
  </div>
</div>